document.addEventListener("DOMContentLoaded", function(event) {
	window.onload = function() {
		

	var targets = document.querySelectorAll(".tabs-list li");
	var forms = document.querySelectorAll(".container-form");
	

	if (forms[0] != undefined) {
		// var currentForm = window.location.pathname.split("/").pop();
		// targets[currentForm].click();
		
		var activeTab = 0;
		var old = 0;
		var dur = 0.4;
		var timelines = [];
		var animation;
		var oldHeight;
		var newHeight = forms[0].offsetHeight;
		for (let i = 0; i < targets.length; i++) {
		  targets[i].index = i;
		  TweenMax.set(forms[i], {autoAlpha:0}); // hide all forms 
		  targets[i].addEventListener("click", doCoolStuff);
		  timelines.push(new TimelineMax({paused:true})); // create an array of timelines
		}

		// create the 4 unique timelines
		/*var split = new SplitText("#article1 h1", { type: "chars" });
		timelines[0].staggerFrom(split.chars, 0.1, { opacity: 0, scale: 0.5, y: 20, rotation:90 }, 0.025);
		timelines[0].from("#article1 p, #article1 img", 0.5, {autoAlpha:0, ease:Linear.easeNone});*/

		/*
		var split = new SplitText("[form-tab='0'] form", { type: "chars" });
		timelines[0].staggerFrom(split.chars, 0.1, { opacity: 0, scale: 0.5, y: 20, rotation:90 }, 0.025);
		timelines[0].from("#article1 p, #article1 img", 0.5, {autoAlpha:0, ease:Linear.easeNone});*/

		timelines[0].staggerFrom("[form-tab='0'] form", 0.8, {autoAlpha:0, ease:Linear.easeNone}, 0.25 );
		timelines[1].staggerFrom("[form-tab='1'] form", 0.8, {autoAlpha:0, ease:Linear.easeNone}, 0.25 );
		timelines[2].staggerFrom("[form-tab='2'] form", 0.8, {autoAlpha:0, ease:Linear.easeNone}, 0.25 );



		var split = new SplitText("[form-tab='2'] .container-interest-one legend, [form-tab='2'] .container-interest-two legend", { type: "chars" });
		timelines[2].staggerFrom(split.chars, 0.1, { opacity: 0, scale: 0.5, y: 20, rotation:90 }, 0.025);
		// timelines[2].from("#article1 p, #article1 img", 0.5, {autoAlpha:0, ease:Linear.easeNone});
		
		/*
		timelines[1].staggerFrom("#article2 h1, #article2 p, #article2 img", 0.8, {autoAlpha:0, ease:Linear.easeNone}, 0.25 );

		timelines[2].from("#article3 h1", 0.6, {rotation:90, opacity:0, transformOrigin:"left top"} );
		timelines[2].from("#article3 img", 0.75, {opacity:0, ease:Linear.easeNone} );

		timelines[3].from("#article4 h1, #article4 p", 0.5, {x:100, autoAlpha:0});
		timelines[3].from(".b", 0.5, {autoAlpha:0, ease:Linear.easeNone});
		timelines[3].staggerFrom(".c img, .d img", 0.75, {yPercent:120}, 0.25);
		*/

		// set initial article block height and position popper on first tab 
		TweenMax.set(forms[0], {autoAlpha:1});
		TweenMax.set(".tabs-list-active", {x:targets[0].offsetLeft, width:targets[0].offsetWidth});
		TweenMax.set(".container-form-data-update", {height:newHeight});

		// play 1st timeline on page load
		timelines[0].play();
		
		function doCoolStuff() {
		  // check if clicked target is new and if the timeline is currently active
		  if(this.index != activeTab) {
		    //if there's an animation in-progress, jump to the end immediately so there aren't weird overlaps. 
		    if (animation && animation.isActive()) {
		      animation.progress(1);
		    }
			


			document.querySelector('[data-tablist]').dataset.tablist = this.dataset.tab;
			
			targets.forEach(el => {
				el.classList.remove('active');
			});
	
			this.classList.add('active');
	
		    animation = new TimelineMax();
		    old = activeTab;
		    oldHeight = newHeight;
		    activeTab = this.index;
		    newHeight = forms[activeTab].offsetHeight;
    
	
		    // animate popper to clicked target
		    animation.to(".tabs-list-active", 0.45, {y:60, ease:Back.easeIn});
		    animation.set(".tabs-list-active", {x:targets[activeTab].offsetLeft, width:targets[activeTab].offsetWidth});    
		    animation.to(".tabs-list-active", 0.45, {y:0, ease:Back.easeOut}, "byebye");
    
		    // slide current article down out of view and then set it to starting position 0 with autoAlpha:0
		    animation.to(forms[old], 0.5, {y:oldHeight, ease:Power3.easeIn }, "byebye");
		    animation.set(forms[old], {autoAlpha:0, y:0 });

		    // resize article block to accommodate new content and change visibility of new content
		    animation.set(forms[activeTab], {autoAlpha:1});
		    animation.to(".container-form-data-update", dur, {height:newHeight, ease:Power3.easeInOut}, "newStuff");
	
		    // add unique timeline     
		    animation.add(timelines[activeTab].play(0), "newStuff+=0.1");
	
			TweenMax.staggerFrom('.form-actions',2,{
			  scale:0.5,
			  opacity:0,
			  delay:0.5,
			  ease:Elastic.easeOut
			},0.2);
			
			function newSize() {
			  TweenMax.set(".tabs-list-active", {x:targets[activeTab].offsetLeft, width:targets[activeTab].offsetWidth});
			  newHeight = forms[activeTab].offsetHeight;
			  TweenMax.set(".article-block", {height:newHeight});
			}
			
			window.addEventListener("resize", newSize);

			// window.addEventListener('resize', function() {
			// 	console.log('addEventListener - resize');
			// }, true);
		  }
		}
		
		
		var currentForm = window.location.pathname.split("/").pop();
		targets[currentForm].click();
	}







	




	
      
    };
});

